"use strict";

angular.module("customer")
.directive("catalogEntryList", function() {
    return {
        restrict: "E",
        controllerAs: "stockCatalogEntryListCtrl",
        templateUrl: require("./catalog-entry-list.directive.html"),
        scope: true,
        bindToController: {
            catalogEntry: "=",
            vendor: "=",
            resetFunction: "&"
        },
        controller: function(
            $scope, $rootScope, $stateParams, $controller
        ) {
            angular.extend(this, $controller("AbstractStockCatalogEntryController", {_this: this, $scope: $scope}));
            var _this = this;
            $scope.catalogId = $stateParams.catalog;

            this.showOrdering = function() {
                return $scope.catalogId && $scope.sortBy.selected === "buyer_catalog_sequence" && !$stateParams.product;
            };

            function getSalesRowClass(showUnitOfMeasureQuantity, showOrdering) {
                var showInventory = $scope.currentView === 'inventory' && !$scope.isOrderTemplate;
                if (showUnitOfMeasureQuantity) {
                    if (!showInventory && showOrdering) {
                        return {
                            "ordering": "col-xs-1",
                            "image": "col-xs-3",
                            "order": "col-xs-4",
                            "unitOfMeasureQuantity": "col-xs-4"
                        };
                    }
                    else if (!showInventory && !showOrdering) {
                        return {
                            "image": "col-xs-4",
                            "order": "col-xs-4",
                            "unitOfMeasureQuantity": "col-xs-4"
                        };
                    }
                    else if (showInventory && !showOrdering) {
                        return {
                            "image": "col-xs-3",
                            "inventory": "col-xs-2",
                            "suggested": "col-xs-2",
                            "order": "col-xs-3",
                            "unitOfMeasureQuantity": "col-xs-2"
                        };
                    }
                    else {
                        return {
                            "ordering": "col-xs-1",
                            "image": "col-xs-3",
                            "inventory": "col-xs-2",
                            "suggested": "col-xs-2",
                            "order": "col-xs-2",
                            "unitOfMeasureQuantity": "col-xs-2"
                        };
                    }
                }
                else {
                    if (!showInventory && showOrdering) {
                        return {
                            "ordering": "col-xs-1",
                            "image": "col-xs-5",
                            "order": "col-xs-6"
                        };
                    }
                    else if (!showInventory && !showOrdering) {
                        return {
                            "image": "col-xs-6",
                            "order": "col-xs-6"
                        };
                    }
                    else if (showInventory && !showOrdering) {
                        return {
                            "image": "col-xs-3",
                            "inventory": "col-xs-3",
                            "suggested": "col-xs-3",
                            "order": "col-xs-3"
                        };
                    }
                    else {
                        return {
                            "ordering": "col-xs-1",
                            "image": "col-xs-3",
                            "inventory": "col-xs-3",
                            "suggested": "col-xs-2",
                            "order": "col-xs-3"
                        };
                    }
                }
            }

            function getReturnsRowClass(showUnitOfMeasureQuantity, showOrdering) {
                if (showUnitOfMeasureQuantity) {
                    if (showOrdering) {
                        return {
                            "ordering": "col-xs-1",
                            "image": "col-xs-3",
                            "order": "col-xs-4",
                            "unitOfMeasureQuantity": "col-xs-4"
                        };
                    }
                    else {
                        return {
                            "image": "col-xs-4",
                            "order": "col-xs-4",
                            "unitOfMeasureQuantity": "col-xs-4"
                        };
                    }
                }
                else {
                    if (showOrdering) {
                        return {
                            "ordering": "col-xs-1",
                            "image": "col-xs-5",
                            "order": "col-xs-6"
                        };
                    }
                    else {
                        return {
                            "image": "col-xs-6",
                            "order": "col-xs-6"
                        };
                    }
                }
            }

            function getCustomDiscountsRowClass(showUnitOfMeasureQuantity, showOrdering) {
                var showInventory = $scope.currentView === 'inventory';
                if (showUnitOfMeasureQuantity) {
                    if (showInventory && !showOrdering) {
                        return {
                            "image": "col-xs-3",
                            "customDiscountedPrice": "col-xs-3",
                            "order": "col-xs-3",
                            "unitOfMeasureQuantity": "col-xs-3"
                        };
                    }
                    else {
                        return {
                            "ordering": "col-xs-1",
                            "image": "col-xs-3",
                            "customDiscountedPrice": "col-xs-3",
                            "order": "col-xs-3",
                            "unitOfMeasureQuantity": "col-xs-2"
                        };
                    }
                }
                else {
                    if (showInventory && !showOrdering) {
                        return {
                            "image": "col-xs-4",
                            "customDiscountedPrice": "col-xs-4",
                            "order": "col-xs-4"
                        };
                    }
                    else {
                        return {
                            "ordering": "col-xs-1",
                            "image": "col-xs-3",
                            "customDiscountedPrice": "col-xs-4",
                            "order": "col-xs-4"
                        };
                    }
                }
            }

            this.getRowClass = function(column, showUnitOfMeasureQuantity) {
                var columnClasses;
                var classValue = "";
                var showOrdering = this.showOrdering();

                if ($scope.activeTab === $scope.TABS.RETURNS || $scope.activeTab === $scope.TABS.INVENTORY_RETURNS) {
                    columnClasses = getReturnsRowClass(showUnitOfMeasureQuantity, showOrdering);
                }
                else if ($scope.activeTab === $scope.TABS.CUSTOM_DISCOUNTS) {
                    columnClasses = getCustomDiscountsRowClass(showUnitOfMeasureQuantity, showOrdering);
                }
                else {
                    columnClasses = getSalesRowClass(showUnitOfMeasureQuantity, showOrdering);
                }

                if (column in columnClasses) {
                    classValue = columnClasses[column];
                }

                return classValue;
            };
        }
    };
});



//////////////////
// WEBPACK FOOTER
// ./customer/sections/stock/catalog-entry/catalog-entry-list.directive.js
// module id = 929
// module chunks = 0